(function () {
    'use strict';

    angular
        .module('completeAir')
        .factory('assignAirCrewService', assignAirCrewService);

    assignAirCrewService.$inject = ['$http', 'CONFIG', 'messageService', 'linkService'];

    function assignAirCrewService($http, CONFIG, messageService, linkService) {
        var urlBase = CONFIG.API_URL + '/' + CONFIG.API_FLIGHT_CONTROL + '/' + CONFIG.API;

        var service = {
            getAssingAirCrewByDate: getAssingAirCrewByDate,
            getAssingAirCrewByDateAircraft: getAssingAirCrewByDateAircraft,
            getAssignAirCrew: getAssignAirCrew,
            getDepartureFlights: getDepartureFlights,
            getRouteNameHref: getRouteNameHref,
            getLoadForm: getLoadForm,
            getOccupationCrewCharge: getOccupationCrewCharge,
            getCommandCrewCharge: getCommandCrewCharge,
            getCrewByCrewType: getCrewByCrewType,
            saveAssignAirCrew: saveAssignAirCrew,
            updateAssignAirCrew: updateAssignAirCrew,
            thereHeadCabinAssistant: thereHeadCabinAssistant
        };
        return service;

        function getAssingAirCrewByDate(date){
            return $http.get(urlBase + '/flights/departure/' + date)
                .then(getComplete)
                .catch(getFailed);

            function getComplete(response) {
                return (response.data._embedded) ? response.data._embedded.flights : [];
            }

            function getFailed() {
                messageService.findAllError('');
            }
        }

        function getAssingAirCrewByDateAircraft(date, aircraftId){
            return $http.get(urlBase + '/flights/departure/' + date + "?aircraftId=" + aircraftId)
                .then(getComplete)
                .catch(getFailed);

            function getComplete(response) {
                return (response.data._embedded) ? response.data._embedded.flights : [];
            }

            function getFailed() {
                messageService.findAllError('');
            }
        }

        function getAssignAirCrew() {
            return $http.get(urlBase + '/flights/departure/1468854480000')
                .then(getComplete)
                .catch(getFailed);

            function getComplete(response) {
                return (response.data._embedded) ? response.data._embedded.flights : [];
            }

            function getFailed() {
                messageService.findAllError('');
            }
        }

        function getDepartureFlights() {
            // return $http.get(urlBase)
            //     .then(getComplete)
            //     .catch(getFailed);
            //
            // function getComplete(response){
            //     return (response.data._embedded.flights) ? response.data._embedded.flights : [];
            // }
            // function getFailed(){
            //     messageService.findAllError('');
            // }
        }

        function saveAssignAirCrew(assignAirCrew) {
            return $http.post(urlBase + '/flights/departure/1468854480000', assignAirCrew)
                .then(saveComplete)
                .catch(getFailed);

            function saveComplete() {
                messageService.register('');
            }

            function getFailed() {
                messageService.registerError('');
            }
        }

        function updateAssignAirCrew(id, assignAirCrew) {
            return $http.put(urlBase + '/airCrewFlights/' + id, assignAirCrew)
                .then(saveComplete)
                .catch(getFailed);

            function saveComplete() {
                messageService.register('');
            }

            function getFailed() {
                messageService.registerError('');
            }
        }

        function getRouteNameHref(url) {
            // return $http.get(url)
            //     .then(getComplete)
            //     .catch(getFailed);
            //
            // function getComplete(response){
            //     return (response.data._embedded.flights) ? response.data._embedded.flights : [];
            // }
            // function getFailed(){
            //     messageService.findAllError('');
            // }
        }

        function getLoadForm(flightId) {
            return $http.get(urlBase + '/airCrewFlights/loadForm?flightId=' + flightId)
                .then(getComplete)
                .catch(getFailed);

            function getComplete(response) {
                return (response.data._embeddeds) ? response.data._embeddeds : [];
            }

            function getFailed() {
                messageService.findAllError('');
            }
        }

        function getOccupationCrewCharge() {
            return $http.get(urlBase + '/occupationCrews/commandCrew/false')
                .then(getComplete)
                .catch(getFailed);

            function getComplete(response) {
                return (response.data._embedded) ? response.data._embedded.occupationCrews : [];
            }

            function getFailed() {
                messageService.findAllError('');
            }
        }

        function getCommandCrewCharge() {
            return $http.get(urlBase + '/occupationCrews/commandCrew/true')
                .then(getComplete)
                .catch(getFailed);

            function getComplete(response) {
                return (response.data._embedded) ? response.data._embedded.occupationCrews : [];
            }

            function getFailed() {
                messageService.findAllError('');
            }
        }

        function getCrewByCrewType(type, id) {
            var ids = 0;
            if (id >= 0) {
                ids = id;
            } else {
                ids = 0;
            }
            var occupationCrewType = "";
            if (type == 0) {
                occupationCrewType = "true";
            } else if (type == 1) {
                occupationCrewType = "false";
            }

            return $http.get(urlBase + '/crew/commandCrew/' + occupationCrewType + '/occupationCrewId/' + ids, {timeout: 30000, cache: false})
                .then(getComplete)
                .catch(getFailed);

            function getComplete(response) {
                return (response.data._embedded) ? response.data._embedded.aircrews : [];
            }

            function getFailed() {
                messageService.findAllError('');
            }
        }

        function thereHeadCabinAssistant(headCabinAssistants, headCabinAssistant, type) {
            var res = false;
            var name = (type === 1) ? "headCabin" : "assistant";
            for (var i = 0; i < headCabinAssistants.length-1; i++){
                if(linkService.getLinkId(headCabinAssistants[i][name]._links.self.href) === linkService.getLinkId(headCabinAssistant._links.self.href)) {
                    res = true;
                    break;
                }
            }
            return res;
        }
    }
})();

